<svg
  xmlns="http://www.w3.org/2000/svg"
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 24 24"
  fill="none"
  focusable="false"
  aria-hidden="true"
>
  <rect width="6" height="18" x="4" y="3" [attr.fill]="fillColor" rx="2" />
  <rect width="6" height="18" x="14" y="3" [attr.fill]="fillColor" rx="2" />
</svg>
